import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomTwoSquareSelectionComponent } from './custom-two-square-selection.component';
import {CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';
import {CustomOhgarTextStaticBannerModule} from '../custom-ohgar-text-static-banner/custom-ohgar-text-static-banner.module';

@NgModule({
  declarations: [CustomTwoSquareSelectionComponent],
  exports: [CustomTwoSquareSelectionComponent],
  imports: [
    CommonModule,
    I18nModule,
    CustomOhgarTextStaticBannerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        TwoSquareSelectionComponent: {
          component: CustomTwoSquareSelectionComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomTwoSquareSelectionModule { }
